import React, { useId } from "react";

import "./ui.css";

/** Groups related form fields without owning validation or submission logic. */
const FormSection = ({
  title,
  description,
  actions,
  children,
  footer,
  className = "",
  contentClassName = "",
  headingLevel = 2,
  ariaLabel,
}) => {
  const generatedId = useId().replace(/:/g, "");
  const titleId = `rg-ui-form-section-title-${generatedId}`;
  const Heading = `h${Math.min(6, Math.max(2, Number(headingLevel) || 2))}`;
  const classes = ["rg-ui-form-section", className].filter(Boolean).join(" ");
  const contentClasses = ["rg-ui-form-section__content", contentClassName]
    .filter(Boolean)
    .join(" ");

  return (
    <section
      className={classes}
      aria-labelledby={title ? titleId : undefined}
      aria-label={!title ? ariaLabel : undefined}
    >
      {(title || description || actions) && (
        <div className="rg-ui-form-section__header">
          <div className="rg-ui-form-section__heading">
            {title && (
              <Heading id={titleId} className="rg-ui-form-section__title">
                {title}
              </Heading>
            )}
            {description && (
              <div className="rg-ui-form-section__description">{description}</div>
            )}
          </div>
          {actions && <div className="rg-ui-form-section__actions">{actions}</div>}
        </div>
      )}
      <div className={contentClasses}>{children}</div>
      {footer && <div className="rg-ui-form-section__footer">{footer}</div>}
    </section>
  );
};

export default FormSection;
